import Vue from 'vue'
import App from './App.vue'
import './assets/css/styles.css'
import router from './router'

import { appConfig } from './config'

// Turn off production tip in console
Vue.config.productionTip = false

// Custom settings for app
Vue.prototype.$appConfig = appConfig

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
